import req from "@/utils/axios.js";
import * as ww from '@wecom/jssdk'
export default {
    getWeComUserInfo(code) {// 传 code 到后端，获取用户信息
        return req.post("/wxShop/auth", {
            state: 'STATE123',
            firm_region_uuid: 1,
            code: code,
        });
    },
    getUserInfo() {// 获取用户信息
        return req.get("/wxShop/userInfo");
    },
    myDepartments() {// 获取我的部门
        return req.get("/wxShop/myDepartments");
    },
    // 门店店员企微邀请码
    shopClerkWeComQRCode(data) {// 门店店员企微邀请码
        return req.get("/wxShop/code/shopClerkWeComQRCode", { ...data });
    },
    // 邀请用户小程序码
    addUserCode(data) {// 邀请用户小程序码
        return req.get("/wxShop/code/addUserCode", { ...data });
    },
    //获取js-sdk签名
    getsignature(url) {// 获取js-sdk签名
        return req.get("/wxShop/signature", {
            firm_region_uuid: 1,
            url: url
        });
    },
    getAgentSignature(url) {// 获取应用签名
        return req.get("/wxShop/agentSignature", {
            firm_region_uuid: 1,
            url: url
        });
    },
    initWeWorkConfig() {
        ww.register({
            corpId: import.meta.env.VITE_WECOM_CORPID, // 必填
            agentId: import.meta.env.VITE_WECOM_AGENTID, // 必填，当前应用的 AgentID
            jsApiList: ["launchMiniprogram","scanQRCode","shareAppMessage"], // 必填
            // 获取“企业签名”的回调
            getConfigSignature: async (url) => {
                // 这里的 url 是 SDK 自动传，不要手动用 window.location.href
                const res = await this.getsignature(url);
                return {
                    timestamp: res.data.timestamp,
                    nonceStr: res.data.nonceStr,
                    signature: res.data.signature,
                };
            },

            // 获取“应用签名”的回调（跳转小程序必须有这个）
            getAgentConfigSignature: async (url) => {
                const res = await this.getAgentSignature(url);
                return {
                    timestamp: res.data.timestamp,
                    nonceStr: res.data.nonceStr,
                    signature: res.data.signature,
                };
            },
        });
    }
}
